const baseUrl = "Finance";

export const getPensionFundsUrl = () => `${baseUrl}/pension-funds`;

export const getBanksUrl = () => `${baseUrl}/banks`;
